import { DatePicker } from '@eastcoal/formily/components/DatePicker'
import { FormItem } from '@eastcoal/formily/components/FormItem'
import { Input } from '@eastcoal/formily/components/Input'
import { SchemaItem } from '@eastcoal/formily/components/SchemaForm/interface'
import { Select } from '@eastcoal/formily/components/Select'
import { TextArea } from '@eastcoal/formily/components/TextArea'

const SELLER_CUSTOMFEEDBACK_ITEMS = [
  '产品质量出入大，无法满足需求。',
  '标的物价格不合适，先观望。',
  '暂无相应资源。',
  '运距较远，运费偏高。',
  '底价偏高，不符合市场行情。',
  '距离远，成本较高。'
]

export const schema: SchemaItem[] = [
  {
    type: 'string',
    name: 'entrustName',
    title: '委托方名称',
    'x-decorator': FormItem,
    'x-component': Input,
    'x-pattern': 'disabled'
  },
  {
    type: 'string',
    name: 'explainContent',
    title: '说明文案',
    'x-decorator': FormItem,
    'x-component': TextArea,
    'x-pattern': 'disabled'
  },
  {
    type: 'string',
    name: 'planName',
    title: '销售计划名称',
    'x-decorator': FormItem,
    'x-component': Input,
    'x-component-props': {
      placeholder: '请输入',
      maxLength: 50,
      showCount: true
    }
  },
  {
    type: 'string',
    name: 'publishTime',
    title: '预告发布时间',
    'x-decorator': FormItem,
    'x-component': DatePicker,
    'x-component-props': {
      showTime: true,
      format: 'YYYY-MM-DD HH:mm'
    }
  },
  {
    type: 'string',
    name: 'productName',
    title: '标的物',
    'x-decorator': FormItem,
    'x-component': Input,
    'x-pattern': 'disabled'
  },
  {
    type: 'string',
    name: 'startPrice',
    title: '起拍价',
    'x-decorator': FormItem,
    'x-component': Input,
    'x-pattern': 'disabled',
    'x-display': "{{ $values.bizType !== 5 ? 'visible' : 'none' }}",
    'x-component-props': {
      addonAfter: '{{$values.priceUnit}}'
    }
  },
  {
    type: 'string',
    name: 'limitPrice',
    title: '限价',
    'x-decorator': FormItem,
    'x-component': Input,
    'x-pattern': 'disabled',
    'x-display': "{{ $values.bizType === 5 ? 'visible' : 'none' }}",
    'x-component-props': {
      addonAfter: '{{$values.priceUnit}}',
      placeholder: '无'
    }
  },
  {
    type: 'string',
    name: 'quantity',
    title: '数量',
    'x-decorator': FormItem,
    'x-component': Input,
    'x-pattern': 'disabled',
    'x-component-props': {
      min: 0,
      addonAfter: '{{ $values.quantityUnit }}'
    }
  },
  {
    type: 'string',
    name: 'customerFeedback',
    title: '客户竞价反馈',
    enum: SELLER_CUSTOMFEEDBACK_ITEMS,
    'x-decorator': FormItem,
    'x-component': Select,
    'x-component-props': {
      mode: 'tags'
    }
  }
]
